import { Button, IconButton, Menu, MenuItem } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Hidden from "@mui/material/Hidden";
import { makeStyles } from '@mui/styles';
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { AccountCircle } from "@mui/icons-material";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "./AuthProvider";
import AuthService from "./services/authService";
import NotesService, { dbOldNotes } from "./services/notesService";

const useStyles = makeStyles((theme) => ({
  icon: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      marginRight: 0,
    },
  },
  menuElemContainer: {
    flexGrow: 1,
    marginLeft: theme.spacing(2),
  },
  button: {
    color: "white",
  },
  userEmail: {
    fontSize: "14px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "10px",
    },
  },
}));

const Header = (props) => {
  const classes = useStyles();
  const { user } = useContext(AuthContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onLogoutClick = () => {
    AuthService.signOut();
    handleClose();
  };

  const onBackupClick = async () => {
    const notes = await dbOldNotes.where("userId", "==", user.uid).get();

    const jsonString = `data:text/json;chatset=utf-8,${encodeURIComponent(
      JSON.stringify({ data: notes.docs.map((doc) => doc.data()) })
    )}`;
    const link = document.createElement("a");
    link.href = jsonString;
    const dateArr = new Date().toJSON().split("T");
    link.download = `taste-notes-data-${dateArr[0]}___${dateArr[1]
      .slice(0, 8)
      .replaceAll(":", "-")}.json`;
    link.click();
  };

  const onMigrateClick = async () => {
    await NotesService.migrate();
  };

  return (
    <AppBar position="relative">
      <Toolbar>
        <MenuBookIcon className={classes.icon} />
        <Hidden smDown>
          <Typography variant="h6" noWrap>
            Tasting notes
          </Typography>
        </Hidden>

        <div className={classes.menuElemContainer}>
          {user && user.uid && user.emailVerified ? (
            <>
              <Button component={Link} to={"/"} className={classes.button}>
                List
                {/* // TODO consider adding chip with notes lengt. Keep notes in the context?
                 &nbsp;&nbsp; <Chip key="55" label="55" variant="default" /> */}
              </Button>
              <Button component={Link} to={"/note"} className={classes.button}>
                Add note
              </Button>
            </>
          ) : null}
        </div>
        {user && user.uid && user.emailVerified ? (
          <div>
            <span className={classes.userEmail}>{user.email}</span>
            <IconButton
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              keepMounted
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              marginThreshold={50}
              open={open}
              onClose={handleClose}
            >
              <MenuItem onClick={onLogoutClick}>Logout</MenuItem>
              <MenuItem onClick={onBackupClick}>Backup your data</MenuItem>
              <MenuItem onClick={onMigrateClick}>Migrate</MenuItem>
            </Menu>
          </div>
        ) : (
          <>
            <Button component={Link} to={"/login"}>
              Login
            </Button>
            <Button component={Link} to={"/register"}>
              Register
            </Button>
            {user && user.emailVerified === false && <p>Verify your email</p>}
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
